import {extend} from 'flarum/common/extend';
import app from 'flarum/forum/app';
import Search from 'flarum/forum/components/Search';
import AlbumSearchSource from './components/AlbumSearchSource';

export default function () {
    extend(Search.prototype, 'sourceItems', items => {
        if (app.forum.cimaiseCanView()) {
            items.add('cimaise-albums', new AlbumSearchSource());
        }
    });
}
